module.exports = __webpack_public_path__ + "img/step1.90a1291c.png";